import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const widgetInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  if (router.url.startsWith('/onboarding') || router.url.startsWith('/operation')) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          router.navigate(['logout']);
        }
        return throwError(error);
      }),
    );
  }

  return next(req);
};
